import $ from 'jquery';
import layout from '../Layout';

export default class DynamicPromoBlocks {
  constructor(section) {
    this.$el = $(section.el);
    this.content = '[data-promo-block-content]';
    this.expandedClass = 'promo-block--expanded';

    // Revert navigation to original state on breakpoint change
    this.layoutHandler = this.onBreakpointChange.bind(this);
    layout.onBreakpointChange(this.layoutHandler);

    this._blockInteraction = this._blockInteraction.bind(this);

    this.$el.on('click.promo-block', this.content, this._blockInteraction);
  }

  /**
   * Remove block's toggled state and attributes when leaving mobile
   */
  onBreakpointChange() {
    if (!layout.isBreakpoint('XS')) {
      this.$el.find(`.${this.expandedClass}`).each((i, content) => {
        this._collapse(content);
      });
    }
  }

  /**
   * Unbind events when section is re-drawn
   */
  onSectionUnload(){
    this.$el.off('.promo-block');
    layout.offBreakpointChange(this.layoutHandler);
  }

  /**
   * Callback to open block on mobile from the TE
   * 
   * @param block
   */
  onSectionBlockSelect(block){
    if (!layout.isBreakpoint('XS')) return;

    this._expand(block.el.querySelector(this.content));
  }

  /**
   * Callback to close block on mobile from the TE
   * 
   * @param block
   */
  onSectionBlockDeselect(block){
    if (!layout.isBreakpoint('XS')) return;

    this._collapse(block.el.querySelector(this.content));
  }

  /**
   * Expand a block on first click, then allow it to behave as normal
   *
   * @param event
   * @private
   */
  _blockInteraction(event) {
    const content = event.currentTarget;
    const clicked = content.getAttribute('data-clicked');

    // On second click, or on desktop, don't interfere with block
    if (clicked || !layout.isBreakpoint('XS')) {
      return;
    }

    event.preventDefault();
    content.setAttribute('data-clicked', 'clicked');

    this._expand(content);
  }

  /**
   * Expand promo block
   * 
   * @param content
   * @private
   */
  _expand(content) {
    const $content = $(content);

    $content
      .addClass('animating animating-in')
      .one('trend', () => {
        $content
          .removeClass('animating animating-in')
          .addClass(this.expandedClass)
          .off('trend');
      });
  }

  /**
   * Collapse a block
   *
   * @param content
   * @private
   */
  _collapse(content) {
    const $content = $(content);

    $content
      .addClass('animating animating-out')
      .one('trend', () => {
        $content
          .removeClass(`animating animating-out ${this.expandedClass}`)
          .off('trend');
        content.removeAttribute('data-clicked');
      });
  }
}
